export default {"src":"/_next/static/media/arrow.ea6c8d90.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};